module.exports = __webpack_public_path__ + "static/wild-muriwai-b7b4909e2cbd1ad596a8318283e57ffe.jpg";